import { render, staticRenderFns } from "./EmploymentHolidaysReportTable.vue?vue&type=template&id=2cb15f49"
import script from "./EmploymentHolidaysReportTable.vue?vue&type=script&lang=js"
export * from "./EmploymentHolidaysReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports